import { render, staticRenderFns } from "./exam.vue?vue&type=template&id=7976653c&scoped=true&"
import script from "./exam.vue?vue&type=script&lang=js&"
export * from "./exam.vue?vue&type=script&lang=js&"
import style0 from "./exam.vue?vue&type=style&index=0&lang=css&"
import style1 from "./exam.vue?vue&type=style&index=1&id=7976653c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7976653c",
  null
  
)

export default component.exports